module.exports = __webpack_public_path__ + "img/ic_usa.76b28cdd.svg";